<template>
  <vs-input v-bind="{
    ...$attrs,
    value,
    labelPlaceholder,
    label,
    autofocus,
    icon,
    iconAfter,
    iconNoBorder,
    iconPack,
    color,
    success,
    danger,
    warning,
    successText,
    warningText,
    dangerText,
    descriptionText,size,
    valIconPack,
    valIconSuccess,
    valIconDanger,
    valIconWarning,
    
  }" v-on="listeners" />
</template>
<script>
export default {
  name: 'vx-input',
  props: {
    value:{
      default:'',
      type:[String,Number]
    },
    labelPlaceholder:{
      default:null,
      type:[String,Number]
    },
    label:{
      default:null,
      type:[String,Number]
    },
    autofocus:{
      default:false,
      type:[Boolean,String]
    },
    icon:{
      default:null,
      type:String
    },
    iconAfter:{
      default:false,
      type:[Boolean,String]
    },
    iconNoBorder:{
      default:false,
      type:Boolean
    },
    iconPack:{
      default:'material-icons',
      type:String
    },
    color:{
      default:'primary',
      type:String
    },
    success:{
      default:false,
      type:Boolean
    },
    danger:{
      default:false,
      type:Boolean
    },
    warning:{
      default:false,
      type:Boolean
    },
    successText:{
      default: null,
      type:String
    },
    dangerText:{
      default: null,
      type:String
    },
    warningText:{
      default: null,
      type:String
    },
    descriptionText:{
      default: null,
      type:String
    },
    size:{
      default:'normal',
      type:String
    },
    valIconPack:{
      default:'material-icons',
      type:String
    },
    valIconSuccess:{
      default: null,
      type:String
    },
    valIconDanger:{
      default: null,
      type:String
    },
    valIconWarning:{
      default: null,
      type:String
    },
    beforeValue: {
      type: Function,
      default: v=>v
    }
  },
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  computed: {
    listeners(){
      return {
        ...this.$listeners,
        input: (evt) => {
          let v = evt
          if (typeof v === 'string' || typeof v === 'number') {
            v = this.beforeValue(v)
            if (Number.isNaN(v)) {
              v = evt
            }
          } else {
            v = this.beforeValue(evt.target.value)
          }

          this.$emit('input', v)
        },
      }
    }
  }
}
</script>